<template>
  <div>
    <v-row dense justify="space-between">
      <v-col>
        <v-card-title>{{ stock.branch.name }}</v-card-title>
      </v-col>
      <v-col cols="12" md="2" class="text-right px-3">
        <v-text-field
            prepend-inner-icon="search"
            v-model="search"
            clearable
            hide-details
        ></v-text-field>

      </v-col>
    </v-row>

    <v-card-text>
      <v-sheet
          class="py-0 px-1"
      >
        <v-chip-group>
          <v-chip v-for="item in getItems" :key="item.product.id">
            <v-avatar
                left
                class=" font-weight-bold"
                :class="item.minimum >=  item.quantity ? 'red white--text' : 'primary onPrimary--text'"
            >{{ item.quantity }}
            </v-avatar>
            {{ item.product.name }}
            <v-avatar><img :src="item.product.image"></v-avatar>
          </v-chip>
        </v-chip-group>
      </v-sheet>
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: "StockPreview",
  props: {
    stock: Object
  },
  data(){
    return {
      search: ''
    }
  },
  computed:{
    getItems(){
      return this.search ? this.stock.items.filter(i => i.hide === false && i.product.name.toLowerCase().includes(this.search)) : this.stock.items.filter(i => i.hide === false)
    }
  }
}
</script>

<style scoped>

</style>
